import React from 'react'
import { HellocianProfileDashboard ,HellocianProjectsSec, WelcomeBanner} from '../../components/components'
import { HellocianSidebarLayout } from '../../components/HellocianSidebar'


const HellocianProjects = () => {
    return (

        <HellocianSidebarLayout currentPath="/overview">
            <div className="bg-[#F5F5F5] dark:bg-[#0b0e14] min-h-screen px-4 py-8 overflow-hidden">
                <WelcomeBanner/>
                <div className="flex flex-col md:flex-row items-start gap-4">
              <HellocianProfileDashboard/>
              <HellocianProjectsSec/>
                 
              </div>
            </div>
        </HellocianSidebarLayout>
    )
}

export default HellocianProjects